/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { URL } from "./data-contracts";

/**
 * @description Generate a URL to preview the published content of a site. The URL will be valid for 1 hour.
 * @tags site-preview
 * @name GetSitePublishingPreviewById
 * @summary Get a site preview URL
 * @request GET:/orgs/{organizationId}/sites/{siteId}/publishing/preview
 * @secure
 */

// @ts-ignore
export const getSitePublishingPreviewById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** ID of the site-space to preview. If not provided, the default site-space will be used. */
    siteSpace?: string;
    /** Rison encoded string of attributes/assertions about the visitor for which we want to preview the site. */
    claims?: string;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    url: URL;
  };
  ResponseStatusCode: 200 | 400;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/publishing/preview",
  method: "get",
  streaming: false,
  tags: ["site-preview"],
  criticalityLevel: "low",
  deprecated: false,
};
